import { render, staticRenderFns } from "./bondFuturesTrading.vue?vue&type=template&id=53665b50&scoped=true&"
import script from "./bondFuturesTrading.vue?vue&type=script&lang=js&"
export * from "./bondFuturesTrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53665b50",
  null
  
)

export default component.exports